export default {
	methods: {
		createAccount () {
			let requestHeaders = {
				'Content-Type': 'application/json; charset=UTF-8',
				'X-Auth-Token': this.$store.getters.getToken
			};
			return this.$http.post(
				'https://utils.yetvpn.com/vpn/user/create',
				{},
				{
					headers: requestHeaders
				}
			)
		}
	}
}